import JSZip from "jszip"
import { saveAs } from "file-saver"
import { apiBaseURL } from "../../../config"
import { get } from "svelte/store"
import { users } from "../../store"

async function fetchImage(url: string): Promise<Blob> {
    const response = await fetch(url)
    if (!response.ok) throw new Error(`Failed to fetch image: ${url}`)
    return await response.blob()
}

function generateFileName(img: Media, type: "images" | "files" = "images"): string {
    const userById = get(users)

    const author = userById[img?.author?.id]?.username?.slice(0, 6) || "Unk"
    if (type === "files") return `${author}_${img.file.path.split("/").pop()}`
    if (!img.location) return `${author}_${img.file.src}`
    if (!img.location.latitude || !img.location.longitude) return `${author}_${img.file.src}`
    const lat = img.location.latitude.toString().replace(".", "d").slice(0, 7)
    const lon = img.location.longitude.toString().replace(".", "d").slice(0, 7)
    const random12 = Math.random().toString(36).substring(2, 14)
    return `${author}_${lat}_${lon}_${random12}.jpg`
}

async function generateZipAndDownload(
    urls: { url: string; name: string }[],
    zipName: string,
    type: "images" | "files" = "images"
) {
    const zip = new JSZip()
    const folder = zip.folder(type == "images" ? "Einsatzbilder" : "Einsatzdateien")

    await Promise.all(
        urls.map(async ({ url, name }) => {
            const blob = await fetchImage(url)
            folder.file(name, blob)
        })
    )

    const content = await zip.generateAsync({ type: "blob" })
    saveAs(content, zipName)
}

export async function downloadAllImages(
    task: TaskOilSpillRemoval | TaskTowing,
    mediaImages: Media[],
    type: "images" | "files" = "images"
) {
    const allMedia = mediaImages.map((img) => ({
        url: `${apiBaseURL}media/${img.id}/${img.file.src}`,
        name: generateFileName(img, type),
    }))
    const currentDate = new Date()
    const formattedDate = currentDate.toLocaleString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    })

    await generateZipAndDownload(allMedia, `einsatz-${formattedDate}.zip`, type)
}

export async function downloadSelectedImages(
    filteredTaskFiles: TaskFile[],
    mediaImages: Media[],
    type: "images" | "files" = "images"
) {
    const selectedMedia = mediaImages.filter((media) => filteredTaskFiles.some((image) => image.id === media.id))

    const allMedia = selectedMedia.map((img) => ({
        url: `${apiBaseURL}media/${img.id}/${img.file.src}`,
        name: generateFileName(img, type),
    }))

    const currentDate = new Date()
    const formattedDate = currentDate.toLocaleString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    })

    await generateZipAndDownload(allMedia, `einsatz-${formattedDate}.zip`, type)
}
